<template>
    <div class="mine">
        <div class="mineTop">
        	<dl>
                <router-link to='/set'>
                    <i class="setImg">
                        <img src="../../../static/images/mine/set.png">   
                    </i> 
                </router-link>

                <dt v-if="tel">{{this.tel}}</dt>
        		<dt v-else>
                    <router-link to='/login'>登录/注册</router-link>
                </dt>
    		    <dd>让租铺变轻松</dd>
        	</dl>
            <div class="headImg"><img src="../../../static/images/mine/zupubao.png"></div>

        </div>
        <div class="mineMain">
            <!-- <div v-show="numShow">
                <div class="lookShop" v-if='num == false'>今日已查看<span>0</span>套铺源（共{{pvCount1}}套／日）</div>
            	<div class="lookShop" v-else>今日已查看<span>{{pvCount1 - numIndex}}</span>套铺源（共{{pvCount1}}套／日）</div>
            </div> -->
            <dl class="dl1" @click="goLookCount">
                <dt><img src="../../../static/images/mine/dl1.png"></dt>
                <dd>查看次数</dd>
                <p v-show="numShow">今日剩余<span>{{numIndex}}</span>次</p>
                <i class="more"><img src="../../../static/images/mine/more.png"></i>
            </dl>
        	<!-- <dl @click="buymember_box">
                <dt><img src="../../../static/images/mine/dl2.png"></dt>
                <dd>会员服务</dd>
                <i class="more"><img src="../../../static/images/mine/more.png"></i>
        	</dl> -->
            <dl @click="goOrder()">
                <dt><img src="../../../static/images/mine/dl3.png"></dt>
                <dd>我的订单</dd>
                <i class="more"><img src="../../../static/images/mine/more.png"></i>
            </dl>
        	<dl>
                <router-link to='/collect'>
            		<dt><img src="../../../static/images/mine/dl4.png"></dt>
            		<dd>我的收藏</dd>
                    <i class="more"><img src="../../../static/images/mine/more.png"></i>
                </router-link>
        	</dl>

            <!-- <dl @click="goMessage()">
                <dt><img src="../../../static/images/mine/message.png"></dt>
                <dd v-if="this.isCount == 1">我的消息<img src="../../../static/images/mine/red-ellipse.png" class="red_round"></dd>
                <dd v-else="isCount">我的消息</dd>
                <i class="more"><img src="../../../static/images/mine/more.png"></i>
            </dl> -->
            <!-- <dl @click="goInvite()">
                <dt><img src="../../../static/images/mine/invite.png"></dt>
                <dd>我的邀请</dd>
                <i class="more"><img src="../../../static/images/mine/more.png"></i>
            </dl> -->

            <dl @click="goMyPublish()">
                <dt><img src="../../../static/images/mine/dl5.png"></dt>
                <dd>我的发布</dd>
                <i class="more"><img src="../../../static/images/mine/more.png"></i>
            </dl>
        	<dl class="dlAbut">
                <router-link to='/aboutUP'>
            		<dt><img src="../../../static/images/mine/dl7.png"></dt>
            		<dd>租铺宝介绍</dd>
                    <i class="more"><img src="../../../static/images/mine/more.png"></i>
                </router-link>
        	</dl>
            <dl class="dlAbut">
                <router-link to='/aboutJoin'>
            		<dt><img src="../../../static/images/mine/join.png"></dt>
            		<dd>加盟租铺宝</dd>
                    <i class="more"><img src="../../../static/images/mine/more.png"></i>
                </router-link>
        	</dl>
        </div>
       <!--  <div class="bannerImg" @click="gobuymember()"> 
            <img src="../../../static/images/mine/banner.png">
        </div> -->
        <!-- <div class="edition">
            <h3>当前版本</h3>
            <h5>V3.6.1</h5>
        </div> -->
        <!-- <div class="quitBtn" v-if="tel" @click="btn()">退出当前帐号</div> -->
    </div>
</template>

<script>
import axios from 'axios';
import qs from "qs";
import Bus from '../../../static/js/bus.js'
export default {
    name: 'mine',
    data () {
        return {
            tel: '',
            numIndex: 0,
            pvCount1: 0,
            num: true,
            numShow: false,
            isVIP:null,
            isCount: null,
            showRedDot: "1",
        }
    },
    computed:{

    },
    methods:{
        // 跳转会员
        buymember_box(){
            if(localStorage.iphone){
                if(this.isVIP == 0){
                    this.$router.push({path:"/goodmember"});
                } else {
                    this.$router.push({path:"/buymember",query:{mine:1}});
                }
            }else{
                this.$router.push({path:"/login"});
            }
        },
        // 跳转我的订单
        goOrder(){
            if(localStorage.iphone){
                this.$router.push({path:"/order"});
            }else{
                this.$router.push({path:"/login"});
            }
        },
        // 跳转我的邀请
        goInvite(){
            if(localStorage.iphone){
                this.$router.push({path:"/inviteFriends"});
            }else{
                this.$router.push({path:"/login"});
            }
        },
        // 跳转我的发布
        goMyPublish(){
            if(localStorage.iphone){
                this.$router.push({path:"/myPublish"});
            }else{
                this.$router.push({path:"/login"});
            }
        },
        // 跳转VIP选址
        gobuymember(){
            this.$router.push({path:"/buymember",query:{mine:1,tab:2}});
        },
        // 跳转查看次数
        goLookCount(){
            if(localStorage.iphone){
                this.$router.push({path:"/lookCount"});
            }else{
                this.$router.push({path:"/login"});
            }
        },

        // 跳转我的消息
        // goMessage(){
        //     if(localStorage.iphone){
        //         this.$router.push({path:"/message"});
        //     }else{
        //         this.$router.push({path:"/login"});
        //     }
        // },
        //
        // isMessage(){
        //     let url =  this.changeData() + '/user/getMsgStatus'
        //     axios(url,{
        //         method: 'post',
        //         params:
        //         {
        //             account: localStorage.iphone,
        //             token: localStorage.token
        //         },
        //     }).then(data => {
        //         console.log(data);
        //         this.isCount = data.data.count;

        //     }).catch(err => {
        //         console.log(err)
        //     });
        // }

        userData(){
            let url =  this.changeData() + '/shop/shopCheckedRecords'
            axios(url,{
                method: 'post',
                params:
                {
                    cityId: sessionStorage.cityId,
                    shopId: "0",
                    type: "0",
                    roof: "0"
                },
            }).then(data => {
                // console.log(data);
                if(data.data.code == 101){
                    this.numShow = true;
                    this.numIndex = data.data.count;
                    // 用户查看次数
                    this.pvCount1 = data.data.pvCount;
                    //判断会员角色
                    this.isVIP = data.data.memberType;
                    // this.isMessage();
                }else if(data.data.code == 401){
                    this.num = false;
                    this.numShow = false;
                    localStorage.clear();
                }
            }).catch(err => {
                console.log(err)
            });
        }
        
    },
    mounted() {
        if(localStorage.token){
            this.userData();
        }
        // let USERS = window.localStorage.getItem("iphone");
        // let TOKEN = window.localStorage.getItem("token");
    },
    updated(){
      if(localStorage.iphone){
        this.tel = localStorage.iphone;
      }else{
        this.tel = "";
      }
    }
}
</script>

<style scoped lang="scss">
body{
	background: #f7f8fa;
}
.mine{
	width: 7.5rem;
    margin-bottom: 2rem;
}
/*top*/
.mineTop{
	width: 7.5rem;
	height: 3.5rem;
	background: url(../../../static/images/mine/backgroundImage.png);
	background-repeat: no-repeat;
    background-size: 100% 100%;
    .setImg{
        display: block;
        margin-left: .4rem;
        margin-top: .3rem;
        margin-bottom: .8rem;
        img{
            width: .4rem;
            height: .4rem;
        }
    }
    .headImg{
        width: 35%;
        height: 3.3rem;
        text-align: center;
        float: left;
        position: relative;
        img{
            width: 1.28rem;
            height: 1.28rem;
            border-radius: 50px;
            position: absolute;
            right: .4rem;
            bottom: .6rem;
        }
    }
    dl{
        width: 65%;
        color: #fff;
        float: left;
        i{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
        dt{
            font-size: 0.48rem;
            font-weight: 600;
            margin-left: .4rem;
            margin-bottom: .2rem;
            line-height: .48rem;
            a{
                color: #fff;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
            }
        }
        dd{
            font-size: 0.22rem;
            font-weight: 400;
            color: #fff;
            margin-left: .4rem;
        }
    }
}

.lookShop{
    height: 0.8rem;
    line-height: 0.9rem;
    text-align: center;
    background: #f7f8fa;
    color: #333;
    font-size: 0.28rem;
    border-bottom: 0.01rem solid #eaeaea;
    span{
        margin-left: .1rem;
        margin-right: .1rem;
        color: red;
    }
}

.mineMain{
    width: 7.5rem;
    dl{
        width: 7.5rem;
        height: 0.98rem;
        background: #fff;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        dt{
            width: 15%;
            height: 0.98rem;
            text-align: center;
            float: left;
            line-height: 0.9rem;
            img{
                width: 0.5rem;
                height: 0.5rem;
            }
        }
        dd{
            width: 70%;
            font-size: 0.32rem;
            color: #333;
            font-weight: 500;
            float: left;
            line-height: 0.98rem;
        }
        .more{
            width: 12%;
            line-height: 0.94rem;
            text-align: center;
            display: inline-block;
            float: right;
            img{
                display: inline-block;
                width: 0.2rem;
                height: 0.26rem;
            }
        }
    }
    .dl1{

        dt{
            width: 15%;
        }
        dd{
            width: 48%;
        }
        p{
            width: 25%;
            float: left;
            text-align: center;
            color: #9f9fa8;
            font-size: .26rem;
            line-height: 0.98rem;
            span{
               color: #ff7700;
               margin: 0 .06rem;
            }
        }
        i{
            float: right;
        }
    }
    .dlAbut{
        padding-bottom: .1rem;
    }

} 

.red_round{
    position: relative;
    top: -8px;
    left: 4px;
  width: 8px;
  height: 8px;
}

/*edition*/
.edition{
    height: 0.98rem;
    line-height: 0.98rem;
    background: #fff;
    border-top: 0.01rem solid #eaeaea;
    border-bottom: 0.01rem solid #eaeaea;
    margin-top: 0.2rem;
    h3{
        font-size: 0.3rem;
        color: #333;
        font-weight: 500;
        float: left;
        padding-left: 0.3rem;
    }
    h5{
        font-size: 0.3rem;
        color: #989898;
        float: right;
        padding-right: 0.3rem;
    }
}
.quitBtn{
    width: 80%;
    height: 0.8rem;
    background: #eaeaea;
    color: #898989;
    font-size: 0.3rem;
    line-height: .8rem;
    text-align: center;
    margin-left: 10%;
    margin-top: .58rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.bannerImg{
    width: 7.3rem;
    height: 1.5rem;
    margin: .2rem auto;
    img{
        width: 7.3rem;
        height: 1.5rem;
    }
}
</style>
















// WEBPACK FOOTER //
// src/components/mine/mine.vue